import React from 'react'
import LoadingSpinner from '../Movie/Loading'
import ApproveCollection from './ApproveCollection'
import CreateCollectionTitleandDescription from './CreateCollectionTitleandDescription'
import CrudSearchBar from './CrudSearchBar'
import ListsDisplayUi from './ListsDisplayUi'

export default function CreateCollectionUi(props) {
  const {
    loading,
    titleEn,
    titleTe,
    discriptionEn,
    discriptionTe,
    selectImage,
    imagePreview,
    setImagePreview,
    toggleSearchbar,
    disableAddListButton,
    isVisiable,
    selectedList,
    sendSelectedList,
    createListCollection,
    disableButton,
    loadPopup,
    ClosePopup,
    approveCollection,
    mode,
    headerLevel,
    setHeaderLevelPersons,
    collectionStatus,
    setHorizontalImage,
    HorizontalImage,
    setTitleEn,
    setTitleTe,
    setDiscriptionEn,
    setDiscriptionTe,
    valueChanged,
    setvalueChanged,
    // editData,
    // movieCollectionIDSData,
    // editHeader,
  } = props
  const TitleEn = value => {
    setTitleEn(value)
    const valueChangedTemp = { ...valueChanged }
    valueChangedTemp.titleEn = true
    setvalueChanged(valueChangedTemp)
  }

  const TitleTe = value => {
    setTitleTe(value)
    const valueChangedTemp = { ...valueChanged }
    valueChangedTemp.titleTe = true
    setvalueChanged(valueChangedTemp)
  }

  const Discription = value => {
    setDiscriptionEn(value)
    const valueChangedTemp = { ...valueChanged }
    valueChangedTemp.DiscriptionEn = true
    setvalueChanged(valueChangedTemp)
  }

  const DiscriptionTe = value => {
    setDiscriptionTe(value)
    const valueChangedTemp = { ...valueChanged }
    valueChangedTemp.DiscriptionTe = true
    setvalueChanged(valueChangedTemp)
  }

  return (
    <>
      <div>
        {loading && <LoadingSpinner />}
        <label>{mode === 'edit' ? 'UpdateListCollection' : 'createListCollection'}</label>
        <CreateCollectionTitleandDescription
          imageValue={props.imageValue}
          titleEn={titleEn}
          titleTe={titleTe}
          discriptionEn={discriptionEn}
          discriptionTe={discriptionTe}
          TitleEn={TitleEn}
          TitleTe={TitleTe}
          Discription={Discription}
          DiscriptionTe={DiscriptionTe}
          selectImage={selectImage}
          imagePreview={imagePreview}
          setImagePreview={setImagePreview}
          headerLevel={headerLevel}
          setHeaderLevelPersons={setHeaderLevelPersons}
          editMode={mode}
          setHorizontalImage={setHorizontalImage}
          HorizontalImage={HorizontalImage}
          valueChanged={valueChanged}
          setvalueChanged={setvalueChanged}
          selectedList={selectedList}
        />
        <button
          className='btn btn-primary rounded-lg mt-2'
          onClick={() => toggleSearchbar()}
          disabled={disableAddListButton}
        >
          Add List
        </button>
        {isVisiable && (
          <CrudSearchBar
            selectedListCrud={selectedList}
            sendSelectedList={sendSelectedList}
            toggleSearchbar={toggleSearchbar}
            isVisiable={isVisiable}
            valueChanged={valueChanged}
            setvalueChanged={setvalueChanged}
          />
        )}
        {!isVisiable && (
          <ListsDisplayUi
            selectedListCrud={selectedList}
            sendSelectedList={sendSelectedList}
            valueChanged={valueChanged}
            setvalueChanged={setvalueChanged}
            // setMovieListTrueValue={setMovieListTrueValue}
          />
        )}
      </div>
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <button
          className='btn btn-primary rounded-lg mt-2'
          onClick={() => createListCollection()}
          disabled={disableButton}
        >
          {mode === 'edit' ? 'Update Collection' : 'Create Collections'}
        </button>
      </div>
      {collectionStatus === 'draft' && (
        <ApproveCollection
          loadPopup={loadPopup}
          ClosePopup={ClosePopup}
          approveCollection={approveCollection}
        />
      )}
    </>
  )
}
